import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MiscService {
  private readonly router = inject(Router);
  private gallerySubject = new BehaviorSubject<boolean>(false);
  galleryActive$: Observable<boolean> = this.gallerySubject.asObservable();

  private secondaryActionsSubject = new BehaviorSubject<boolean>(false);
  secondaryActionsActive$: Observable<boolean> = this.secondaryActionsSubject.asObservable();

  activeGallery(state: boolean): void {
    this.gallerySubject.next(state);
  }

  toggleSecondaryActions(): void {
    this.secondaryActionsSubject.next(!this.secondaryActionsSubject.value);
  }

  isRemote(): boolean {
    return this.router.url.includes('smartphoto') && this.router.url.includes('remote=true');
  }
}
